module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        address: {
            type: ['string', 'null']
        },
        address2: {
            type: ['string', 'null']
        },
        district: {
            type: ['string', 'null']
        },
        city: {
            type: ['string', 'null']
        },
        region: {
            type: ['string', 'null']
        },
        postalCode: {
            type: ['string', 'null']
        },
        country: {
            type: ['string', 'null']
        },
        email: {
            type: ['string', 'null']
        },
        phone: {
            type: ['string', 'null']
        }
    }
};
